import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
export default /*@__PURE__*/_defineComponent({
  __name: 'menu-item',
  props: {
    route: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_menu_item = _resolveComponent("menu-item", true);
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      return __props.route.meta.showMenu ? (_openBlock(), _createElementBlock("div", _hoisted_1, [__props.route.children && __props.route.children.length > 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 0,
        index: __props.route.path
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(__props.route.meta.title), 1)]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.route?.children, child => {
          return _openBlock(), _createBlock(_component_menu_item, {
            key: child.path,
            route: child
          }, null, 8, ["route"]);
        }), 128))]),
        _: 1
      }, 8, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: __props.route.path
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.route.meta.title), 1)]),
        _: 1
      }, 8, ["index"]))])) : _createCommentVNode("", true);
    };
  }
});